import { render } from "./Menu.vue?vue&type=template&id=2aa2413c&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=2aa2413c&scoped=true&lang=css"

import exportComponent from "/Users/macbookpro/Documents/Github/sinfoapp/sinfoapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa2413c"]])

export default __exports__